// Data-URI prefixes permitted for a dashboard thumbnail. The admin uploader
// transcodes to JPEG, but PNG is accepted as an input format too.
const allowedThumbnailPrefixes = [
    "data:image/jpeg;base64,",
    "data:image/png;base64,",
];
// Maximum stored thumbnail string length. The uploader transcodes to a
// <=1280x720 JPEG (well under this); the cap guards against DB bloat and
// oversized API responses from malicious or buggy clients. ~2 MB of base64
// is roughly ~1.5 MB decoded — generous for a tile image, but bounded.
export const maxThumbnailLength = 2_000_000;
/**
 * Validate an optional dashboard thumbnail submitted by a client. Returns an
 * error message describing why it is invalid, or `null` when it is acceptable
 * (including when absent — the field is optional). Enforces a format allowlist
 * (PNG/JPEG data URI), a maximum size, and that the payload is base64.
 */
export function validateThumbnail(thumbnail) {
    if (thumbnail === null || thumbnail === undefined) {
        return null;
    }
    if (!allowedThumbnailPrefixes.some((prefix) => thumbnail.startsWith(prefix))) {
        return "Thumbnail must be a PNG or JPEG data URI";
    }
    if (thumbnail.length > maxThumbnailLength) {
        return "Thumbnail exceeds the maximum allowed size";
    }
    const base64 = thumbnail.slice(thumbnail.indexOf(",") + 1);
    if (base64.length === 0 || !/^[A-Za-z0-9+/]+={0,2}$/.test(base64)) {
        return "Thumbnail is not valid base64 image data";
    }
    return null;
}
//# sourceMappingURL=supersetDashboard.js.map